//@flow
import TrackJs from './trackjs-interface';
import ScriptLoader from './scriptLoader';
import GlobalData from './globalData';
import CookiesData from './cookies-data';
import Heap from './heap-interface';
import Model from './Model/model';
import CustomerActions from '../Actions/customer';

// the event could be 'customer' or 'order'
// for a customer event, the data includes email and customer id
// for an order event, the data includes order id, amount, and email

function _updateFriendBuyVisitorData() {
  global.friendbuyAPI.push([
    'getVisitorStatus',
    CustomerActions.setFriendBuyData,
  ]);
}

function _addSubscriptions() {
  global.friendbuyAPI.push(["subscribe", "widgetActionTriggered", (action) => {

    // Create guest customer on advocate email capture
    if (action.actionName === 'advocateEmailCaptured') {
      CookiesData.set('email', { email: action.email });
      Heap.identify(action.email);
      CustomerActions.createCustomer({ email: action.email });
    }

    // Save email and identify friend when captured
    if(action.actionName === 'friendEmailCaptured') {
      CookiesData.set('email', { email: action.email });
      Heap.identify(action.email);
    }
  }]);
}

function _callFriendbuyFunction(event, data) {
  try {
    global.friendbuyAPI.push(['track', event, data]);
    _updateFriendBuyVisitorData();
  } catch (e) {
    TrackJs.console.debug(`error: ${e}`);
    TrackJs.track(`FriendbuyV2 error`);
  }
}

class FriendbuyUtils {
  loadFriendbuy() {
    if (global.friendbuyAPI) return;
    global.friendbuyAPI = [];

    if (global.inServer) return;

    const merchantId:?string = GlobalData.get('friendbuy', 'merchantId');
    if (!merchantId) return;

    global.friendbuyAPI.push(['merchant', merchantId]);
    _updateFriendBuyVisitorData();
    _addSubscriptions();
    ScriptLoader.addScript('friendbuyV2', GlobalData.get('friendbuy', 'url'));
    ScriptLoader.addScript('friendbuyV2-campaign', GlobalData.get('friendbuy', 'campaignsUrl'));
  }

  track(event:string, data:Object) {
    this.loadFriendbuy();
    _callFriendbuyFunction(event, data);
  }
}

type Advocate = {
  customerId:string,
  firstName:string,
};

type VisitorPayload = {
  attributionId:?string,
  campaignId:?string,
  referralCode:string,
  referralCodeBlocked:boolean,
  isSelfReferral:boolean,
  advocate:?Advocate,
};

export type FriendBuyVisitor = {
  status:string,
  signature:string,
  payload:VisitorPayload,
};
export class FriendBuyVisitorModel extends Model<FriendBuyVisitor>{
  getStatus():string {
    return this.attributes.status;
  }
}

export default new FriendbuyUtils();
